import { showFrontendToast } from "../../shared/utils"

export const showToast = (message, type = 'error') => {
  return showFrontendToast(message, type);
};